'use strict';

const Mn = require('backbone.marionette');
const Template = require('balus/ui/template/body/group-role/title.hbs');

module.exports = Mn.View.extend({
    template: Template,
    templateContext: function() {
        return {
            name: this.model.getName()
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group-role/title.js